// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"9c73157c","239":"3beb3c4a","453":"2e0a5263","667":"fda1418d"}[chunkId] + ".chunk.js";
};